import { apiSlice } from "../../../../../api/ApiService";
import { getHeadersFromRedux } from "../../../../../utility/functions/common-functions";

const myLearningWidgetApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMyLearningWidgetContent: builder.query({
      query: ({ patientId, preferredLanguage }) => {
        const headers = getHeadersFromRedux();
        headers["X-Language"] = preferredLanguage;
        return {
          url: `/api/v1/Patient/${patientId}/my-learning-widget`,
          method: "GET",
          headers,
        };
      },
      providesTags: [{ type: "LearningWidget" }],
    }),
  }),
  overrideExisting: false,
});

export const { useGetMyLearningWidgetContentQuery } = myLearningWidgetApi;
export default myLearningWidgetApi;

